<script setup lang="ts">

import { computed, useSlots } from 'vue'

defineProps({
  title: {
    type: String,
    default: ''
  },
  help: {
    type: String,
    default: ''
  },
  topPadding: {
    type: String,
    default: '1'
  },
  bottomPadding: {
    type: String,
    default: '-'
  },
  noPadding: {
    type: Boolean,
    default: false
  },
  contentHeight: {
    type: String,
    default: ''
  }
})

// Check if the default slot has content
const slots = useSlots();
const slotHasContent = computed(() => {
  const slotContent = slots.default?.();
  return slotContent && slotContent.length > 0;
});

</script>

<template>
  <div :class="'mt-' + topPadding + ' mb-' + bottomPadding + ' text-subtext rounded'">
    <div v-if="title || $slots.title" class="pl-2 py-1 text-metal-500 font-semibold bg-metal-800 shadow rounded-t overflow-x-clip text-nowrap border-t border-metal-750">
      <slot name="title" v-if="$slots.title"></slot>
      <span v-else v-html="title"></span>
    </div>
    <div v-if="help" :class="[
        'text-subtext bg-metal-900 p-2 flex-grow',
        {
          'mb-1': slotHasContent,
          'rounded': !title,
          'rounded-b': title
        }
      ]"> {{ help }}</div>
    <div v-if="slotHasContent" :class="[
        'bg-metal-900 flex-grow',
        {
           'p-2': !noPadding,
           'rounded': help || !title,
           'rounded-b': !help && title
         },
        contentHeight
      ]">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>